import PropTypes from 'prop-types'
import SkeletonComponent from '../../../../../components/stories/atoms/skeleton'

const ProjectMenuTileLoadList = ({ children, isLoading = false }) => {
  const listSize = 20

  const skeletonShape = {
    display: 'flex',
    width: '255px',
    minHeight: '300px',
    height: '100%',
    borderRadius: '16px',
    flex: '0 0 auto'
  }

  return (
    <SkeletonComponent
      isLoading={isLoading}
      skeletonShape={skeletonShape}
      elementQuantity={listSize}
    >
      {children}
    </SkeletonComponent>
  )
}

ProjectMenuTileLoadList.propTypes = {
  children: PropTypes.node,
  isLoading: PropTypes.bool
}

export default ProjectMenuTileLoadList
